export default function GestionCarteraFilters({
  filters,
  asesores = [],
  loading = false,
  errors = {},
  formError = '',
  onChange,
  onApply,
  onReset,
}) {
  const getErrorMessage = (error) => {
    if (!error) return '';
    return Array.isArray(error) ? error[0] : error;
  };

  const fieldClass = (hasError) =>
    [
      'w-full rounded-2xl border bg-white px-4 py-3 text-sm text-slate-900 shadow-sm transition',
      hasError
        ? 'border-red-400 ring-2 ring-red-200 focus:border-red-400 focus:ring-red-300'
        : 'border-slate-200 focus:border-red-300 focus:ring-2 focus:ring-red-200',
    ].join(' ');

  return (
    <section className="space-y-4">
      {!!formError ? (
        <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700" role="alert">
          {formError}
        </div>
      ) : null}

      <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-[minmax(260px,1fr)_minmax(220px,280px)_10rem_10rem]">
        <div className="min-w-0">
          <label htmlFor="search" className="mb-2 block text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
            BUSCAR CRÉDITO
          </label>
          <input
            id="search"
            name="search"
            type="text"
            value={filters.search}
            onChange={onChange}
            placeholder="Cliente, DNI o número de crédito..."
            className={fieldClass(Boolean(errors.search))}
            aria-invalid={Boolean(errors.search)}
            aria-describedby={errors.search ? 'gestion_cartera_search_error' : undefined}
          />
          <div className="h-5">
            {!!errors.search ? (
              <p id="gestion_cartera_search_error" className="mt-1 text-xs text-red-600">
                {getErrorMessage(errors.search)}
              </p>
            ) : null}
          </div>
        </div>

        <div className="min-w-0">
          <label htmlFor="asesor_id" className="mb-2 block text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
            ASESOR ACTUAL
          </label>
          <select
            id="asesor_id"
            name="asesor_id"
            value={filters.asesor_id}
            onChange={onChange}
            className={fieldClass(Boolean(errors.asesor_id))}
            aria-invalid={Boolean(errors.asesor_id)}
            aria-describedby={errors.asesor_id ? 'gestion_cartera_asesor_error' : undefined}
          >
            <option value="">Todos los asesores</option>
            {asesores.map((asesor) => (
              <option key={asesor.id} value={asesor.id}>
                {asesor.nombre}{asesor.activo ? '' : ' (INACTIVO)'}
              </option>
            ))}
          </select>
          <div className="h-5">
            {!!errors.asesor_id ? (
              <p id="gestion_cartera_asesor_error" className="mt-1 text-xs text-red-600">
                {getErrorMessage(errors.asesor_id)}
              </p>
            ) : null}
          </div>
        </div>

        <div className="lg:pt-7">
          <button
            type="button"
            onClick={onApply}
            disabled={loading}
            className="w-full rounded-full bg-red-600 px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-slate-300"
          >
            {loading ? 'Cargando...' : 'Aplicar'}
          </button>
        </div>

        <div className="lg:pt-7">
          <button
            type="button"
            onClick={onReset}
            disabled={loading}
            className="w-full rounded-full border border-red-200 bg-white px-6 py-3 text-sm font-semibold text-red-600 shadow-sm transition hover:border-red-300 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-70"
          >
            Limpiar
          </button>
        </div>
      </div>
    </section>
  );
}